import { createAction, props } from '@ngrx/store';

export const addUser = createAction('[User] Add User', props<{ user: any }>());
export const removeUser = createAction('[User] Remove User', props<{ userId: string }>());
export const updateUser = createAction('[User] Update User', props<{ user: any }>());
